import React, { Component } from 'react';
import ModalPDF from './ModalPDF/ModalPDF';
import {
  ModalContainer,
  OptionsWrapper,
  ShareBarWrapper,
  BarBtn,
  BarTitle,
  BarTitleWrappper,
  CloseBtnWrapper,
  ShareBar,
  ModalIcon,
  BackIcon,
  Background,
  TextWrapper,
  OptionTitle
} from './CompartirElement';
import { getTranslatedKey } from '../../Utils/TranslateUtils';
import ShareComponent from './Componentes/ShareComponent';
import PrintComponent from './Componentes/PrintComponent';
import InfoComponent from './Componentes/InfoComponent';
import { Switch, SwitchCB, SwitchSpan } from '../NavbarElements';
import { displayComponents, visorVariables } from '../../Utils/VisorsUtils';
import DownloadLoad from './Componentes/Download/Load/DownloadLoad';
import { SVGNewTab } from '../../Sidebar/SidebarElements';

// Creación del canvas del mapa
const mapCanvas = document.createElement('canvas');
let mapImg = new Image();
mapImg.crossOrigin = 'Anonymous';

let scale = null;
let scaleInt = null;

const date = new Date();
let day = date.getDate();
let month = date.getMonth() + 1;
let year = date.getFullYear();
let data = '';
if (month < 10) {
  data = `${day}-0${month}-${year}`;
} else {
  data = `${day}-${month}-${year}`;
}

let docName = `Hipermapa ${data}.jpg`;

export default class Compartir extends Component {
  constructor(props) {
    super(props);
    this.state = {
      url: '', //url parametritzada a exportar
      pdfMenu: false, // variable de estado que guarda si el menú para exportar en PDF está activo
      initialPos: null, // variable de estado de la posición inicial de la información de punto cuando se empieza en drag
      initialSize: null // variable de estado de la altura inicial de la información de punto cuando se empieza en drag
    };
    this.dragImg = new Image(0, 0);
  }

  componentDidMount = () => {
    document.addEventListener('keydown', this.onEscClick);
  };
  componentWillUnmount() {
    document.removeEventListener('keydown', this.onEscClick);
  }

  onEscClick = (e) => {
    if (e.key === 'Escape') {
      this.onClickModalClose();
    }
  };

  // Función para cerrar el modal
  onClickModalClose = () => {
    this.setState({ pdfMenu: false });
    this.props.toggleShare(undefined, true);
  };

  // Convertir canvas en imagen del mapa
  createCanvas = () => {
    mapCanvas.width = window.innerWidth;
    mapCanvas.height = window.innerHeight - 40;
    const mapContext = mapCanvas.getContext('2d');

    // Fondo blanco para el export en JPG
    mapContext.fillStyle = 'white';
    mapContext.fillRect(0, 0, mapCanvas.width, mapCanvas.height);

    Array.prototype.forEach.call(document.querySelectorAll('.ol-layer canvas'), function (canvas) {
      if (canvas.width > 0) {
        const opacity = canvas.parentNode.style.opacity;
        mapContext.globalAlpha = opacity === '' ? 1 : Number(opacity);
        const transform = canvas.style.transform;
        const matrix = transform
          .match(/^matrix\(([^\(]*)\)$/)[1]
          .split(',')
          .map(Number);
        CanvasRenderingContext2D.prototype.setTransform.apply(mapContext, matrix);
        mapContext.drawImage(canvas, 0, 0);
      }
      // Hacemos que el canvas sea el SRC de la imagen creada para evitar problemas de CORS
      mapImg.addEventListener('load', () => {
        mapContext.drawImage(mapImg, 0, 0);
      });
      mapImg.src = mapCanvas.toDataURL('image/jpeg');
    });
    mapContext.globalAlpha = 1;
    mapContext.setTransform(1, 0, 0, 1, 0, 0);
    this.forceUpdate();
    // inches per metres * DPI(del pdf) * resolución * Compensación por redondear
    scale = Math.round(39.37 * 72 * this.props.map.getView().getResolution() * 0.9407);
    scaleInt = scale;
    scale = scale.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  };

  togglePDF = () => {
    if (this.state.pdfMenu === false) {
      this.createCanvas();
    }
    this.setState({ pdfMenu: !this.state.pdfMenu });
  };

  handleImgDownload = () => {
    this.createCanvas();
  };
  compartirBack = () => {
    this.setState({ pdfMenu: false });
  };

  switch = () => {
    this.props.toggleFontSize();
  };

  handleGuia = () => {
    const newTab = window.open(visorVariables.urlManual, '_blank');
    newTab.focus();
  };
  handleFaqs = () => {
    const newTab = window.open(visorVariables.urlFaqs, '_blank');
    newTab.focus();
  };
  handleTutorial = () => {
    const newTab = window.open(visorVariables.urlTutorial, '_blank');
    newTab.focus();
  };

  render() {
    return (
      <Background active={this.state.pdfMenu}>
        <ModalContainer info={this.props.modalShareKind === 'info'} id="ShareContainer" modalOpen={this.props.modalShareOpen}>
          <ShareBar>
            <ShareBarWrapper>
              <BarTitleWrappper>
                <BarTitle fontSizeEnabled={this.props.fontSizeEnabled}>
                  {this.state.pdfMenu ? (
                    <BackIcon onClick={() => this.compartirBack()}>
                      <g>
                        <g>
                          <path d="M420.361,192.229c-1.83-0.297-3.682-0.434-5.535-0.41H99.305l6.88-3.2c6.725-3.183,12.843-7.515,18.08-12.8l88.48-88.48c11.653-11.124,13.611-29.019,4.64-42.4c-10.441-14.259-30.464-17.355-44.724-6.914c-1.152,0.844-2.247,1.764-3.276,2.754l-160,160C-3.119,213.269-3.13,233.53,9.36,246.034c0.008,0.008,0.017,0.017,0.025,0.025l160,160c12.514,12.479,32.775,12.451,45.255-0.063c0.982-0.985,1.899-2.033,2.745-3.137c8.971-13.381,7.013-31.276-4.64-42.4l-88.32-88.64c-4.695-4.7-10.093-8.641-16-11.68l-9.6-4.32h314.24c16.347,0.607,30.689-10.812,33.76-26.88C449.654,211.494,437.806,195.059,420.361,192.229z"></path>
                        </g>
                      </g>
                    </BackIcon>
                  ) : null}
                  {this.props.modalShareKind === 'share'
                    ? getTranslatedKey('compartir')
                    : this.props.modalShareKind === 'download'
                    ? this.props.user?.user && this.props.intranet
                      ? getTranslatedKey('gestion')
                      : getTranslatedKey('titleNoUser')
                    : this.props.modalShareKind === 'print'
                    ? getTranslatedKey('print')
                    : this.props.modalShareKind === 'info'
                    ? getTranslatedKey('searchHelp')
                    : this.props.modalShareKind === 'acces'
                    ? getTranslatedKey('accessibilitat')
                    : getTranslatedKey('help')}
                </BarTitle>
              </BarTitleWrappper>
              <CloseBtnWrapper>
                <BarBtn
                  title={getTranslatedKey('tancar')}
                  onClick={() => this.onClickModalClose()}
                  aria-label={getTranslatedKey('aria_closeModalShare')}>
                  <ModalIcon fontSizeEnabled={this.props.fontSizeEnabled} viewBox="0 0 24 24" fill="#fff">
                    <path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
                  </ModalIcon>
                </BarBtn>
              </CloseBtnWrapper>
            </ShareBarWrapper>
          </ShareBar>
          {this.state.pdfMenu ? (
            <ModalPDF
              fontSizeEnabled={this.props.fontSizeEnabled}
              map={this.props.map}
              scaleInt={scaleInt}
              togglePDF={this.togglePDF}
              pdfMenu={this.state.pdfMenu}
              arrayLayers={this.props.arrayLayers}
              canvas={mapCanvas}
              img={mapImg.src}
              createCanvas={this.createCanvas}
              scale={scale}
            />
          ) : (
            <OptionsWrapper info={this.props.modalShareKind === 'info'} download={this.props.modalShareKind === 'download'}>
              {this.props.modalShareKind === 'share' ? (
                <ShareComponent
                  transparenciaFons={this.props.transparenciaFons}
                  fontSizeEnabled={this.props.fontSizeEnabled}
                  map={this.props.map}
                  arrayLayers={this.props.arrayLayers}
                  fonsActiu={this.props.fonsActiu}
                />
              ) : this.props.modalShareKind === 'print' ? (
                <PrintComponent
                  docName={docName}
                  mapImg={mapImg}
                  fontSizeEnabled={this.props.fontSizeEnabled}
                  handleImgDownload={this.handleImgDownload}
                  togglePDF={this.togglePDF}
                />
              ) : this.props.modalShareKind === 'info' ? (
                <InfoComponent fontSizeEnabled={this.props.fontSizeEnabled} />
              ) : this.props.modalShareKind === 'download' ? (
                <DownloadLoad
                  intranet={this.props.intranet}
                  user={this.props.user}
                  toggleAlert={this.props.toggleAlert}
                  mapName={this.props.mapName}
                  favList={this.props.favList}
                  vectorTilesSource={this.props.vectorTilesSource}
                  toggleLoadDBMap={this.toggleLoadDBMap}
                  loadMap={this.props.loadMap}
                  transparenciaFons={this.props.transparenciaFons}
                  fontSizeEnabled={this.props.fontSizeEnabled}
                  map={this.props.map}
                  arrayLayers={this.props.arrayLayers}
                  fonsActiu={this.props.fonsActiu}
                />
              ) : this.props.modalShareKind === 'acces' ? (
                <>
                  <TextWrapper fontSizeEnabled={this.props.fontSizeEnabled}>
                    {getTranslatedKey('mida')}
                    <Switch>
                      <SwitchCB type="checkbox" check={this.props.fontSizeEnabled} onClick={() => this.switch()}></SwitchCB>
                      <SwitchSpan></SwitchSpan>
                    </Switch>
                  </TextWrapper>
                </>
              ) : this.props.modalShareKind === 'help' ? (
                <>
                  <OptionTitle onClick={() => this.props.toggleAjuda()} fontSizeEnabled={this.props.fontSizeEnabled}>
                    {getTranslatedKey('help')}
                  </OptionTitle>
                  {displayComponents.manual && (
                    <OptionTitle onClick={() => this.handleGuia()} fontSizeEnabled={this.props.fontSizeEnabled}>
                      {getTranslatedKey('guiaUs')}
                      <SVGNewTab id="Layer_1" enable-background="new 0 0 20 20" viewBox="0 0 20 20" fill="white">
                        <g>
                          <path d="m14 0v2h2.6l-8.3 8.3 1.4 1.4 8.3-8.3v2.6h2v-6z" />
                          <path d="m16 18h-14v-14h9v-2h-11v18h18v-11h-2z" />
                        </g>
                      </SVGNewTab>
                    </OptionTitle>
                  )}
                  {displayComponents.faqs && (
                    <OptionTitle onClick={() => this.handleFaqs()} fontSizeEnabled={this.props.fontSizeEnabled}>
                      {getTranslatedKey('faqs')}
                      <SVGNewTab id="Layer_1" enable-background="new 0 0 20 20" viewBox="0 0 20 20" fill="white">
                        <g>
                          <path d="m14 0v2h2.6l-8.3 8.3 1.4 1.4 8.3-8.3v2.6h2v-6z" />
                          <path d="m16 18h-14v-14h9v-2h-11v18h18v-11h-2z" />
                        </g>
                      </SVGNewTab>
                    </OptionTitle>
                  )}
                  {displayComponents.tutorial && (
                    <OptionTitle onClick={() => this.handleTutorial()} fontSizeEnabled={this.props.fontSizeEnabled}>
                      {getTranslatedKey('tutorial')}
                      <SVGNewTab id="Layer_1" enable-background="new 0 0 20 20" viewBox="0 0 20 20" fill="white">
                        <g>
                          <path d="m14 0v2h2.6l-8.3 8.3 1.4 1.4 8.3-8.3v2.6h2v-6z" />
                          <path d="m16 18h-14v-14h9v-2h-11v18h18v-11h-2z" />
                        </g>
                      </SVGNewTab>
                    </OptionTitle>
                  )}
                </>
              ) : null}
            </OptionsWrapper>
          )}
        </ModalContainer>
      </Background>
    );
  }
}
